export default __webpack_public_path__ + "81708a79729e10dbbfe89c62d403dc79.png";